import type { CSS } from '../../stitches.config';
import { type SizingScale, isSpacingValue } from './sizes';

export type SizeTypes = SizingScale | string;
export type SizeProps = { size?: SizeTypes };

export function sizeCSS(size?: SizeTypes): CSS {
  if (
    size === 'auto' ||
    size === 'fit-content' ||
    size === 'max-content' ||
    size === 'min-content'
  ) {
    return { size };
  }

  if (size === 'full' || size === '100%') {
    return { size: '100%' };
  }

  if (size === 'screen') {
    return { size: '100vw' };
  }

  if (typeof size === 'number' && isSpacingValue(size)) {
    return { size: `$${size}` };
  }

  if (typeof size === 'string') {
    return { size };
  }

  return {};
}
